/* __next_internal_client_entry_do_not_use__ useHeaderStore,HeaderStoreProvider auto */ import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
/**
 * Context store to keep track of header state
 */ var _createContextStore = createContextStore({
    isShowingMenu: false,
    isShowingMobileSearch: false,
    isShowingAccountMenu: false,
    isSearchVisible: false,
    query: ""
}, {
    name: "HeaderStore"
}), useHeaderStore = _createContextStore.useStore, HeaderStoreProvider = _createContextStore.Provider;
export { useHeaderStore, HeaderStoreProvider };
